<div class="loyalty-program">
  <lp-header
    [ngClass]="headerVisible ? 'header' : 'header header_hide'"
    (add)="addProduct()"
    [search]="search"
    (searchChange)="onSearchChange($event)"
    [(city)]="city"
    (cityChange)="refresh()"
    (applyFilterAndChangeRoute)="onChangeCategory($event, true)"
  ></lp-header>

  <tui-scrollbar *ngIf="productListMode === 'map'; else productListTmp" (scroll)="onScroll()">
    <ng-container [ngTemplateOutlet]="carouselCategoriesTmp"></ng-container>

    <div class="map-layout" [ngStyle]="{ height: mapHeight + 'px' }">
      <ng-container
        *ngIf="isDesktop; else mapProductListButtonTmp"
        [ngTemplateOutlet]="mapProductListTmp"
      ></ng-container>

      <app-map
        [ngStyle]="{ height: mapHeight + 'px', width: mapWidth + 'px' }"
        [center]="city?.geoPoint"
        [placemarks]="placemarksForMap"
        [(bounds)]="bounds"
        (boundsChange)="refresh()"
      ></app-map>
    </div>
  </tui-scrollbar>

  <ng-template #productListTmp>
    <tui-scrollbar
      infiniteScroll
      [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50"
      (scrolled)="onScrollProducts()"
      (scroll)="onScroll()"
      [scrollWindow]="false"
      [alwaysCallback]="true"
      [infiniteScrollDisabled]="!hasMoreProducts"
    >
      <ng-container [ngTemplateOutlet]="carouselCategoriesTmp"></ng-container>

      <ng-container *ngIf="hasFilter">
        <ng-container *tuiLet="products$ | async as products">
          <ng-container *ngIf="products?.items?.length || productsListLoading; else noDataTmp">
            <div class="loyalty-program__products">
              <lp-products-list-category
                *ngIf="showProductsFromFavoriteCategories"
                [categories]="productsFromFavoriteCategories$ | async"
                [productListMode]="productListMode"
                [showIsFavorite]="true"
                [size]="tuiElementMediumSize"
                (applyFilterAndChangeRoute)="onChangeCategory($event, true)"
              ></lp-products-list-category>

              <app-loader-wrapper [loading]="productsListLoading">
                <lp-products-list
                  class="products-list"
                  [title]="
                    showProductsFromFavoriteCategories ? ('components.loyaltyProgram.labels.seeAlso' | translate) : ''
                  "
                  [products]="products?.items"
                  [productListMode]="productListMode"
                  [showIsFavorite]="true"
                ></lp-products-list>
              </app-loader-wrapper>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>

      <div *ngIf="hasMoreProducts" class="loyalty-program__loading-marker">
        {{ 'components.loyaltyProgram.list.appending' | translate }}
      </div>
    </tui-scrollbar>
  </ng-template>
</div>

<ng-template #carouselCategoriesTmp>
  <lp-carousel-categories
    [ngStyle]="{ 'padding-top': headerHeight + 'px' }"
    class="loyalty-program__carousel"
    [filter]="filter"
    (applyFilter)="onChangeCategory($event, false)"
    (applyFilterAndChangeRoute)="onChangeCategory($event, true)"
  >
    <app-list-mode-switcher
      [(mode)]="productListMode"
      [useMode]="isDesktop ? ['grid', 'map'] : ['list', 'grid', 'map']"
      [storageKey]="listModeStorageKey"
    ></app-list-mode-switcher>
  </lp-carousel-categories>
</ng-template>

<ng-template #mapProductListTmp>
  <tui-scrollbar class="product-list__wrapper">
    <ng-container *ngIf="mapProducts$ | async as products; else loaderTmp">
      <div *ngIf="products.length; else noDataTmp" class="product-list">
        <lp-product-card *ngFor="let product of products" [product]="product" [showIsFavorite]="true"></lp-product-card>
      </div>
    </ng-container>
  </tui-scrollbar>
</ng-template>

<ng-template #mapProductListButtonTmp>
  <app-dropdown-button
    class="product-list-button"
    appearance="floating"
    [icon]="'@tui.list'"
    [label]="'Список объявлений'"
  >
    <ng-container [ngTemplateOutlet]="mapProductListTmp"></ng-container>
  </app-dropdown-button>
</ng-template>

<ng-template #loaderTmp>
  <app-loader-wrapper [loading]="true"></app-loader-wrapper>
</ng-template>

<ng-template #noDataTmp>
  <lp-no-data-found></lp-no-data-found>
</ng-template>
